<!--
 * @Date: 2022-10-27 16:50:55
 * @LastEditTime: 2023-08-17 15:03:19
 * @Description:
-->
<template>
  <div class="login_box">
    <!-- <div >登录</div> -->
    <div class="login">
      <div v-if="is_logo_show" class="logo">
        <div class="logo_img" style="margin-right: 5px;">
          <el-image
            v-if="agent_info.logo"
            style="width: 50px; height: 50px"
            :src="agent_info?agent_info.logo:require('../images/yixiang_logo.png')"
            fit="cover"
          />

          <img v-else class="logo_img_cover" :src="agent_info?agent_info.logo:require('../images/yixiang_logo.png')" alt="">
        </div>
        <div class="logo_text">
          {{ agent_info?agent_info.name:'易象' }}
        </div>
        <div class="line" />
        <div class="logo_text2">
          代理商
        </div>
      </div>
      <div class="login_box2">
        <div class="inpt">
          <div class="text">
            用户名
          </div>
          <el-input v-model="username" placeholder="请输入用户名" />
        </div>
        <div class="inpt">
          <div class="text">
            密码
          </div>
          <el-input v-model="password" type="password" placeholder="请输入密码" />
        </div>
        <div class="inpt" style="margin-bottom: 30px;">
          <div class="text">
            验证码
          </div>
          <el-input v-model="code" placeholder="请输入验证码" type="number" @keyup.enter.native="login">
            <div slot="append" class="verify_code">
              <img :src="`${url}/verifi?token=${token}`" alt="" @click="change_code">
            </div>
          </el-input>
        </div>
        <div class="remember_box" style="margin-bottom: 30px;text-align: left">
          <el-checkbox v-model="remember" @change="change_remember">
            记住密码
          </el-checkbox>
        </div>
        <!-- <div class="btn" @click="goto('/index/body1')">登录</div> -->
        <div class="btn" @click="login">
          登录
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ajax, { getUrl } from '@/api/api'
import { setToken, setType, setAuthority, setSid, setAccountId, setWorkerType } from '@/utils/auth.js'
import md5 from 'md5'
let strong = {}
try {
  strong = localStorage.getItem('yx_agent_auth') ? JSON.parse(localStorage.getItem('yx_agent_auth')) : {}
} catch (e) {
  strong = {}
}
export default {
  data() {
    return {
      url: getUrl(),
      token: '',
      activeIndex: '1',
      activeIndex2: '1',
      username: strong.username || '',
      password: strong.password || '',
      code: '',
      agent_info: '',
      remember: localStorage.getItem('yx_agent_remember') == 'true',
      is_logo_show: false
    }
  },
  mounted() {
    const token = md5(Date.parse(new Date()) + Math.random())
    this.token = token
    this.api_get_agent_logo()
  },
  methods: {
    // API
    api_get_agent_logo() {
      const _this = this
      const query = this.$route.query
      console.log('====', query)

      if (query && JSON.stringify(query) != '{}' && query.id) {
        ajax({
          url: '/verifi/get_agent_logo',
          data: {
            id: query.id
          },
          ajaxfn: res => {
            if (res.data.status == 1) {
              const info = res.data.info
              if (info && JSON.stringify(info) != '' && info != null && info.logo) {
                this.agent_info = info
                const link = document.querySelector("link[rel*='icon']")
                // link.href = info.logo
                link.href = 'data:,'
                document.title = info.name + '代理后台'
              } else {
                const link = document.querySelector("link[rel*='icon']")
                link.href = 'favicon.ico'
                document.title = '易象代理后台'
              }
              _this.is_logo_show = true
            }
          }
        })
      } else {
        localStorage.setItem('agent_info', '')
        _this.is_logo_show = true
      }
    },
    change_remember(e) {
      localStorage.setItem('yx_agent_remember', e)
    },
    change_code() {
      const new_token = md5(Date.parse(new Date()) + Math.random())
      this.token = new_token
      setToken(new_token)
    },
    login() {
      ajax({
        url: '/login',
        data: { username: this.username, password: this.password, code: this.code, token: this.token },
        ajaxfn: res => {
          if (res.data.status === -3) {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
            this.change_code()
          }
          if (res.data.status === 1) {
            if (res.data.logo) {
              const agent_info_obj = {
                // id: query && query.id ? query.id : '',
                id: res.data.id || '',
                logo: res.data.logo,
                name: res.data.name
              }
              localStorage.setItem('agent_info', JSON.stringify(agent_info_obj))
            } else {
              localStorage.setItem('agent_info', '')
            }

            setSid(res.data.s_id)
            setType(res.data.type)
            setToken(res.data.token)
            setAuthority(res.data.super_admin)
            setAccountId(res.data.id)
            if (this.remember) {
              localStorage.setItem('yx_agent_auth', JSON.stringify({
                username: this.username, password: this.password
              }))
            }
            localStorage.setItem('_yixiang_agent_name', res.data.name)
            setWorkerType(res.data.worker_type)
            localStorage.setItem('agent_id', res.data.id)
            localStorage.setItem('agent_type', res.data.agent_type)
            this.$parent.title = res.data.name
            setTimeout(() => {
              this.$router.push('/index/body1')
            }, 200)
          }
        }
      })
    }
  }
}
</script>

<style>
.login_box .login {
  position: relative;
  width: 430px;
  margin: 213px auto 0;
}

.login_box .login_box2 {
  position: relative;
  padding: 40px 40px 54px;
  background-color: #ffffff;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
}

.login_box .inpt {
  position: relative;
  margin-bottom: 20px;
}

.login_box .text {
  margin-bottom: 10px;
  text-align: left;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #6d6c6d;
}

.login_box .el-input__inner {
  height: 50px !important;
  background-color: #fafafa;
}

.login_box .btn {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #ff5f2e;
  text-align: center;
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.login_box .el-input-group__append {
  color: #ffffff;
}

.login_box .logo {
  display: flex;
  position: relative;
  align-items: center;
  margin-bottom: 26px;
  justify-content: center;
}

/* .login_box .logo .logo_img img {
  width: 22px;
  height: 25px;
} */
.logo_img_cover {
  width: 22px;
  height: 25px;
}

.login_box .logo_text {
  margin-bottom: 7px;
  font-size: 26px;
  font-family: MicrosoftYaHei;
  color: rgba(255, 95, 46, 1);
}

.login_box .line {
  height: 17px;
  width: 1px;
  background-color: #d8d8d8;
  margin-left: 10px;
  margin-right: 10px;
}

.login_box .logo_text2 {
  margin-bottom: 7px;
  font-size: 20px;
  font-family: MicrosoftYaHei;
  color: rgba(153, 153, 153, 1);
}

.login_box .el-input-group__append,
.el-input-group__prepend {
  padding: 0;
  border: none;
}
</style>
